const BOOKING_PAYMENT_STATUS_VALIDATED = 'VALIDATED';
const BOOKING_PAYMENT_STATUS_OPTION = 'OPTION';
const BOOKING_PAYMENT_STATUS_PACKAGE_UPGRADE = 'PACKAGE_UPGRADE';
const BOOKING_PAYMENT_STATUS_ADDITIONAL_SERVICE = 'ADDITIONAL_SERVICE';
const BOOKING_PAYMENT_STATUS_PICK_YOUR_ROOM = 'PICK_YOUR_ROOM';
const BOOKING_PAYMENT_STATUS_UPGRADE_ROOM = 'UPGRADE_ROOM';
const BOOKING_PAYMENT_STATUS_CART = 'CART';
const BOOKING_PAYMENT_STATUS_SERVICES_IN_OPTION = 'SERVICES_IN_OPTION';

export {
  BOOKING_PAYMENT_STATUS_VALIDATED,
  BOOKING_PAYMENT_STATUS_OPTION,
  BOOKING_PAYMENT_STATUS_PACKAGE_UPGRADE,
  BOOKING_PAYMENT_STATUS_ADDITIONAL_SERVICE,
  BOOKING_PAYMENT_STATUS_PICK_YOUR_ROOM,
  BOOKING_PAYMENT_STATUS_UPGRADE_ROOM,
  BOOKING_PAYMENT_STATUS_CART,
  BOOKING_PAYMENT_STATUS_SERVICES_IN_OPTION,
};
